import type { ReactNode } from 'react';
import { SortingRule } from 'react-table';
import { OpportunityEntity } from '../api/models/AccountEntity';
import { RoleEnum } from 'src/api';

export type Role = `${RoleEnum}`;

export type SelectOptions = {
	value: string;
	label: string;
};

export interface TableContainerProps {
	columns: any;
	data: any;
	loading: any;
	setDownloadData?: any;
	error: any;
	dbClickType?: string;
	presetFilter?: any;
	onSortChange?: (rule: SortingRule<Object>[]) => void;
	dblClickCallback?: (row: any) => void;
	className?: string;
	hiddenColumns?: string[] | undefined;
	pageSize?: number;
	showPageSelector?: boolean;
	onPageSizeChange?: (pageSize: number) => void;
	isExpandable?: boolean;
	renderRowSubComponent?: (props: { row: any }) => ReactNode;
	getRowId?: (row: any, index: number) => string;
	useControlledState?: (state: any) => any;
}

export type ReactSelectOption = {
	value: string;
	label: string;
	subtitle?: string;
};

export type AccountTypeOption = ReactSelectOption & {
	value: 'Azienda' | 'Privato' | 'Libero Professionista';
};

export interface PaginatorObject {
	total_pages: number;
	current_page: number;
	first_page: number;
	last_page: number;
	previous_page: number;
	next_page: number;
	has_previous_page: boolean;
	has_next_page: boolean;
	total_results: number;
	results: number;
	first_result: number;
	last_result: number;
}

export type OpportunityFunnelValues = {
	name: string;
	entity?: OpportunityEntity | null;
	Tipologia__c: ReactSelectOption | null;
	Canale__c: ReactSelectOption | null;
	channel?: ReactSelectOption | null;
	Noleggiatore__c: ReactSelectOption | null;
	commissions: string;
	notes: string;
	driveItEasy?: boolean;
	driverEmail?: string;
	targa?: string | null;
	telaio?: string | null;
	dataFineContrattoDriveItEasy?: string | null
	nomePartner: ReactSelectOption | null
	Offerta_Edison__c?: ReactSelectOption | null
	salesUser?: string | null
	referenceUser?: string | null
	referenceUserId?: string | null
	backupUsers?: string[] | null
	referenceUserLabel?: string | null;
	LeadSource?: ReactSelectOption | null;
	provvigioniPassive?: string | null;
	provvigioniSegnalatore?: string | null;
	segnalatore?: string | null;
	ragioneSocialeSegnalatore?: string | null;
}

export enum Markets {
	it = 'it',
	es = 'es',
}

export interface TableSkeletonProps {
	cols?: number;
	rows?: number;
}

export type RemoteSelectOption = {
	label: string;
	value: string;
	disabled: boolean;
	disabledReason?: string;
};
